<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <v-sheet
      color="grey lighten-5"
      rounded="0"
      class="px-4"
    >
      <page-sub-header>
        组织架构
        <template #subtitle>
          管理您的组织结构，新建和计划新的门店
        </template>
      </page-sub-header>
    </v-sheet>

    <div style="display: grid;grid-template-columns: 270px 1fr">
      <v-sheet
        class="pa-4"
        rounded="0"
        elevation="0"
      >
        <v-text-field
          outlined
          dense
          hide-details
          placeholder="输入门店名称以搜索"
          prepend-inner-icon="mdi-magnify"
        />
        <tree-list-view
          @selected="e=>activeDepartmentName=e"
          class="mt-4"
          :tree-object="structure"
        />
        <v-card
          outlined
          class="pa-1 mt-4 text-body-1
          d-flex align-center justify-center"
        >
          <v-icon
            left
            class="ml-n2"
          >
            mdi-plus
          </v-icon>
          新建分部
        </v-card>
      </v-sheet>
      <v-sheet
        v-if="activeDepartment"
        class="pa-4 px-6"
        style="border-left: 1px solid #f6f6f6"
        rounded="0"
      >
        <div class="d-flex align-baseline mt-1">
          <div class="text-body-1">
            {{ activeDepartment.name }}
          </div>
          <div class="mr-2 ml-4 text--secondary text-body-2">
            下属门店数
          </div>
          <div class="text-body-1">
            {{ storeList.length }}
          </div>
        </div>
        <template v-if="storeList.length>0">
          <div class="mt-4 d-flex">
            <div
              style="width: 170px;"
              class="mr-2"
            >
              <v-select
                outlined
                :menu-props="{offsetY:true}"
                dense
                class="text-body-2"
                :items="['全部','正常']"
                value="全部"
                hide-details
              >
                <template #prepend-inner>
                  <div
                    style="height: 26px"
                    class="text-no-wrap d-flex flex-column
                  text-body-2
                  text--secondary
                   align-center justify-center pr-4"
                  >
                    门店状态
                  </div>
                </template>
              </v-select>
            </div>
            <div
              style="width: min-content"
            >
              <v-select
                outlined
                :menu-props="{offsetY:true}"
                dense
                class="text-body-2"
                :items="['仅展示该代理的直属','展示全部']"
                value="仅展示该代理的直属"
                hide-details
              />
            </div>
            <v-spacer />
            <v-btn
              icon
              outlined
              class="mr-2"
              tile
              style="border-radius: 8px !important;"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              color="amber lighten-4 black--text"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              添加门店
            </v-btn>
          </div>
        </template>
        <template v-else>
          <div
            style="height: 400px"
            class="d-flex flex-column align-center justify-center"
          >
            <v-icon>mdi-cloud-search-outline</v-icon>
            <div class="text-body-1 mt-2">
              暂时没有门店
            </div>
          </div>
        </template>
      </v-sheet>
    </div>
    <v-dialog
      v-model="newStoreDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            新增门店
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="newStoreDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex justify-center align-center my-4">
          <v-card
            class="d-flex align-center justify-center"
            color="grey lighten-4"
            elevation="0"
            height="253"
            style="position: relative;flex-shrink: 0;"
            width="190"
            @click="addNewStore('bind')"
          >
            <div class="text-center">
              <v-icon size="48">
                mdi-home-circle
              </v-icon>
              <div>
                现有门店
              </div>
            </div>
          </v-card>
          <v-card
            class="d-flex align-center justify-center ml-10"
            color="grey lighten-4"
            elevation="0"
            height="253"
            style="position: relative;flex-shrink: 0;"
            width="190"
            @click="addNewStore('buy')"
          >
            <div class="text-center">
              <v-icon size="48">
                mdi-home-plus
              </v-icon>
              <div>
                新增门店
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="newAgentDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            新增代理
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="newAgentDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            代理名字:
          </div>
          <v-text-field
            v-model="agentInfo.name"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            代理模式:
          </div>
          <v-text-field
            v-model="agentInfo.agentType"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            代理分成:
          </div>
          <v-text-field
            v-model="agentInfo.divide"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            分成模式:
          </div>
          <v-text-field
            v-model="agentInfo.divideType"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            代理区域:
          </div>
          <v-text-field
            v-model="agentInfo.area"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            最大门店数量:
          </div>
          <v-text-field
            v-model="agentInfo.maxStore"
            dense
            hide-details
            outlined
          />
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            代理合同:
          </div>
          <v-text-field
            v-model="agentInfo.agencyContract"
            dense
            hide-details
            outlined
          />
        </div>
        <v-btn
          class="mt-8 mb-2 amber lighten-4"
          outlined
          width="100%"
        >
          保存
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import TreeListView from '@/views/AadenPages/branding/fragments/BrandingManage/TreeListView.vue'
import { nodesInTree, structure } from '@/views/AadenPages/branding/fragments/BrandingManage/fakeData'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'

export default {
  name: 'BrandingManage',
  computed: {
    structure () {
      return structure
    },
    activeDepartment () {
      return nodesInTree(structure).find(it => it.name === this.activeDepartmentName)
    },
    storeList () {
      return nodesInTree(this.activeDepartment).map(it => it?.stores ?? []).flat()
    }
  },
  components: {
    PageSubHeader,
    TreeListView
  },
  data () {
    return {
      storeInfo: {
        name: '',
        adress1: '',
        adress2: '',
        postCode: '',
        city: '',
        state: '',
        taxNumber: '',
        telephone: '',
        iban: '',
        bic: '',
        kontoInhaber: '',
        bankName: '',
        latitude: '',
        longitude: '',
        inhalterName: '',
        inhalterLastName: '',
        inhalterTitle: '',
        emailAddress: ''
      },
      agentInfo: {
        name: '',
        agentType: '',
        divide: '',
        divideType: '',
        area: '',
        maxStore: '',
        agencyContract: ''
      },
      activeDepartmentName: structure.name,
      newAgentDialog: false,
      newStoreDialog: false
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
